import { render, staticRenderFns } from "./PpiRekapAuditPage.vue?vue&type=template&id=218c345f&"
import script from "./PpiRekapAuditPage.vue?vue&type=script&lang=ts&"
export * from "./PpiRekapAuditPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports